export default "__VITE_ASSET__5btO02zP__"